// extracted by mini-css-extract-plugin
export default {"container":"badge_container__sfSf9"};